'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var domCache = require('dom-cache');

var dom = {};

var init = function(data) {

	$.extend(dom, domCache);
	dom.topWindow = $(window.parent);
	dom.topBody = $(window.parent.document.body);
	dom.iframe = $('#promo_' + data.id, window.parent.document);
	dom.promo = $('#promo_' + data.id);
	dom.promoLayout = dom.promo.find('.promo__layout');
	dom.formWidget = dom.promo.find('.fb-form');

};

dom.init = init;

module.exports = dom;
